import React, { useState, useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { AiOutlineDelete } from "react-icons/ai";
import { BiCommentError } from "react-icons/bi";
import { RiFilePaperLine } from "react-icons/ri";
import { BsDownload } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import DashLayout from "../../layouts/DashLayout";
import Overlay from "../../components/Overlay";
import { useParams } from "react-router";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteYearEvent,
  getYearEventById,
  updateYearEvent,
} from "../../store/actions/YearEventActions";
import { style } from "../../styles/Style";
import { ToastContainer } from "react-toastify";

function ViewAnnualEvent() {
  const dispatch = useDispatch();

  const yearEvent = useSelector((state) => state.yearEventState.yearEvent);
  const loaders = useSelector((state) => state.loadersState);

  const [event, setEvent] = useState({
    id: "",
    name: "",
    startTime: "",
    endTime: "",
    budget: "",
    comments: "",
    place: "",
  });

  const [editAnnualEvent, setEditAnnualEvent] = useState(0);
  function editAnnualEventController(passedEvent) {
    setEditAnnualEvent(!editAnnualEvent);
    setEvent({
      id: passedEvent.id,
      name: passedEvent.eventName,
      startTime: passedEvent.startTime
        ? new Date(passedEvent.startTime).toISOString().slice(0, -1)
        : "",
      endTime: passedEvent.endTime
        ? new Date(passedEvent.endTime).toISOString().slice(0, -1)
        : "",
      budget: passedEvent.budget,
      comments: passedEvent.comments,
      place: passedEvent.location,
    });
  }
  const [addAnnualEvent, setAddAnnualEvent] = useState(0);
  function AddAnnualEventController() {
    setAddAnnualEvent(!addAnnualEvent);
  }

  const { eventid } = useParams();
  const selectedAnnualEvent = eventid;
  let history = useHistory();

  // handle delete
  const handleDeleteEvent = (id) => {
    dispatch(deleteYearEvent(id, redirectAfterDelete));
  };

  function redirectAfterDelete() {
    history.push("/services/events");
  }

  useEffect(() => {
    dispatch(getYearEventById(selectedAnnualEvent));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // handle event  submit
  const handleAnnualEventSubmit = (e) => {
    e.preventDefault();
    const id = event.id;
    const annualEvent = {
      id: event.id,
      location: event.place,
      comments: event.comments,
      eventName: event.name,
      startTime: event.startTime,
      endTime: event.endTime,
      budget: event.budget,
    };
    dispatch(updateYearEvent(annualEvent, id, closeAnnualEventAfterUpdating));
  };

  // closing product after u

  function closeAnnualEventAfterUpdating() {
    editAnnualEventController({
      id: "",
      name: "",
      startTime: "",
      endTime: "",
      budget: "",
      comments: "",
      place: "",
    });
  }

  console.log(yearEvent);
  return (
    <DashLayout>
      <div className="text-xs">
        <ToastContainer />
      </div>

      {(!loaders.yearEvent.loadingOne && !yearEvent.id) |
      loaders.yearEvent.loadingOneFailedMsg ? (
        <div
          className={
            !loaders.yearEvent.loadingOneFailedMsg
              ? "bg-white mx-10 h-60 flex  text-xs rounded text-center py-2 px-4 text-gray-500 font-semibold"
              : "bg-red-100 mx-10 h-60 flex text-xs rounded  text-center py-2 px-4 text-red-500 font-semibold"
          }
        >
          <div className="m-auto">
            {!loaders.yearEvent.loadingOneFailedMsg ? (
              <div className="flex-col">
                <RiFilePaperLine className="text-3xl mx-auto my-3" />{" "}
                <p>This annualEvent is not found</p>{" "}
              </div>
            ) : (
              <div className="flex-col">
                <BiCommentError className="text-3xl mx-auto my-3" />{" "}
                <p>{loaders.yearEvent.loadingOneFailedMsg}</p>{" "}
              </div>
            )}
          </div>
        </div>
      ) : loaders.yearEvent.loadingOne ? (
        <div className="bg-white mx-10 h-60 flex">
          <div className="spinner m-auto indigo-spinner">
            <div className="bounce1"></div>
            <div className="bounce2"></div>
            <div className="bounce3"></div>
          </div>
        </div>
      ) : (
        <div className="bg-white mx-10">
          <div className="flex flex-col md:flex-row p-10 pl-10 pb-0">
            <h2 className="font-semibold">
              <Link
                to="/services/events"
                className="hover:text-indigo-500 text-indigo-300"
              >
                Annual events {">"}
              </Link>{" "}
              <span className="font-normal">{yearEvent.eventName}</span>
            </h2>
            <div className="md:m-auto mt-2 md:mr-0">
              <button
                className={
                  "p-2 mr-2 rounded text-white bg-indigo-500 hover:bg-indigo-400"
                }
                onClick={() => {
                  editAnnualEventController(yearEvent);
                }}
              >
                <FiEdit />
              </button>
              <button
                className={
                  "p-2 mr-2 rounded text-red-500 border border-red-500 hover:bg-red-100"
                }
                onClick={() => {
                  handleDeleteEvent(selectedAnnualEvent);
                }}
              >
                <AiOutlineDelete
                  className={
                    loaders.yearEvent.deletingAction &&
                    loaders.yearEvent.deletingAction.deleting
                      ? " refresh-loader"
                      : " "
                  }
                />
              </button>

              <button
                className={
                  "p-2 mr-2 rounded text-gray-500 border border-gray-200 hover:bg-gray-100"
                }
              >
                <BsDownload />
              </button>
            </div>
          </div>
          {/* insurance tabs */}
          <div className="flex mt-2 flex-wrap">
            <div className="w-full">
              <div className="relative flex flex-col min-w-0 break-words  w-full mb-2">
                <div>
                  <div className="tab-content tab-space">
                    {/* AnnualEvents table */}
                    <div className={"flex flex-col"} id="link1">
                      <div className="pb-5 px-0 flex flex-wrap  w-full">
                        {/* Academics table */}
                        <div className="w-full flex flex-col my-3 ml-10 mr-10 border">
                          <div className="flex flex-row border-b p-5">
                            <div className="font-semibold w-2/12">
                              Event type
                            </div>
                            <div>{"Annual event"}</div>
                          </div>
                          <div className="flex flex-row border-b p-5">
                            <div className="font-semibold w-2/12">
                              Event Station
                            </div>
                            <div>{yearEvent.location}</div>
                          </div>
                          <div className="flex flex-row border-b p-5">
                            <div className="font-semibold w-2/12">
                              Event Period
                            </div>
                            <div className="flex flex-col">
                              <div className="flex-row flex">
                                <p className="bg-indigo-100 w-2 h-2 font-normal text-indigo-500 m-auto ml-0 mr-2 rounded-full">
                                  {" "}
                                </p>{" "}
                                <span>
                                  {yearEvent.startTime
                                    ? new Date(yearEvent.startTime)
                                        .toISOString()
                                        .slice(0, -1)
                                    : ""}
                                </span>
                              </div>
                              <div className={"flex-row flex"}>
                                <p className="border border-indigo-200 w-2 h-2 font-normal text-indigo-500 m-auto ml-0 mr-2  rounded-full">
                                  {" "}
                                </p>{" "}
                                <span>
                                  {" "}
                                  {yearEvent.endTime
                                    ? new Date(yearEvent.endTime)
                                        .toISOString()
                                        .slice(0, -1)
                                    : ""}{" "}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-row border-b p-5">
                            <div className="font-semibold w-2/12">Budget</div>
                            <div>{yearEvent.budget}</div>
                          </div>
                          <div className="flex flex-row  p-5">
                            <div className="font-semibold w-2/12">Comments</div>
                            <div className="text-justify w-8/12">
                              {yearEvent.comments}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*edit AnnualEvent overlay  */}
          <div
            className={
              addAnnualEvent || editAnnualEvent ? "flex w-screen" : "hidden"
            }
          >
            <Overlay>
              <div className="bg-white m-auto  rounded">
                <div
                  className={
                    loaders.yearEvent.message
                      ? "bg-red-100 text-xs rounded text-center py-2 text-red-500 font-semibold"
                      : "hidden"
                  }
                >
                  <p>{loaders.yearEvent.message}</p>
                </div>
                <div className="p-10">
                  <div className="flex">
                    <h2 className="font-semibold  w-80">
                      {"Change event info"}
                    </h2>
                    <div className="m-auto mr-0">
                      <button
                        className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                        onClick={() => {
                          addAnnualEvent
                            ? AddAnnualEventController()
                            : editAnnualEventController({
                                id: "",
                              });
                        }}
                      >
                        <IoCloseOutline className="text-white" />{" "}
                      </button>
                    </div>
                  </div>{" "}
                  <div className="flex flex-wrap">
                    <div className="w-full">
                      <div className="flex flex-wrap">
                        <div className="w-full">
                          <form
                            className="relative flex flex-col min-w-0 break-words bg-white w-full mb-2"
                            onSubmit={handleAnnualEventSubmit}
                          >
                            <div>
                              <div className="flex flex-col pt-3">
                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Name </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={event.name}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          name: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="py-2 w-full">
                                  <label>Starts at </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="datetime-local"
                                      className={style.field.input}
                                      value={event.startTime}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          startTime: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="py-2 w-full">
                                  <label>Ends at </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="datetime-local"
                                      className={style.field.input}
                                      value={event.endTime}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          endTime: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="py-2 w-full">
                                  <label> Budget(*frw) </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="number"
                                      className={style.field.input}
                                      value={event.budget}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          budget: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="py-2 w-full">
                                  <label>Event station </label>
                                  <div className={style.field.parentDiv}>
                                    <input
                                      type="text"
                                      className={style.field.input}
                                      value={event.place}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          place: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>

                                {/*  field */}
                                <div className="py-2 w-full">
                                  <label>Comments </label>
                                  <div className={style.field.parentDiv}>
                                    <textarea
                                      className={style.field.input}
                                      value={event.comments}
                                      onChange={(e) =>
                                        setEvent({
                                          ...event,
                                          comments: e.target.value,
                                        })
                                      }
                                    ></textarea>
                                  </div>
                                </div>

                                {/* save btn */}
                                <button
                                  type="submit"
                                  className={style.loginBtn}
                                  disabled={loaders.yearEvent.sendingLoader}
                                >
                                  {!loaders.yearEvent.sendingLoader ? (
                                    <p className="m-auto">{"Save"}</p>
                                  ) : (
                                    <div className="spinner m-auto">
                                      <div className="bounce1"></div>
                                      <div className="bounce2"></div>
                                      <div className="bounce3"></div>
                                    </div>
                                  )}{" "}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Overlay>
          </div>
        </div>
      )}
    </DashLayout>
  );
}

export default ViewAnnualEvent;
